<template>
    <div class="selectServer">
        <Head :headInfo='headInfo' @onClickLeft='onBack' />
        <div class="refundGood">
            <h3>退款商品</h3>
            <div class="refundGood_good">
                <GoodTemplate :goods='goodList[0]' :showStatus='true' />
            </div>
        </div>
        <div class="refundGood">
            <h3>选择服务类型<sup>*</sup></h3>
            <div class="item" v-for="(item, index) in serverList" :key="index" @click="onApply(index)">
                <i class="iconfont iconicon_dianpu"></i>
                <div class="item_center">
                    <div class="title" v-text="item.title"></div>
                    <p>{{ item.message }} </p>
                </div>
                <van-icon class="arrowRight" name="arrow" />
            </div>
        </div>
    </div>
</template>

<script>
import Head from '../../common/head'
import GoodTemplate from './components/goodTemplate'
export default {
    name: 'selectServer',
    components: {
        Head,
        GoodTemplate
    },
    data () {
        return {
            headInfo: {
                title: '选择服务'
            },
            goodList: JSON.parse(localStorage.getItem('refundData')),
            serverList: [
                {
                    title: '拒收退款',
                    message: '没签收，要求退货退款'
                },
                {
                    title: '退货退款',
                    message: '货已收，有质量问题，需要退货退款'
                },
                {
                    title: '换货',
                    message: '货已收，有质量问题，需要换货'
                }
            ]
        }
    },
    methods: {
        onBack () {
            this.$router.go(-1)
        },
        onApply (val) {
            this.$router.push({ path: '/b2b/refundOrder/applyRefund', query: { type: val, deliveryOrderId: this.$route.query.deliveryOrderId } })
        }
    }
}
</script>

<style lang="scss" scoped>
.refundGood {
    margin-top: 20px;
    background-color: #ffffff;
    padding: 32px 0;
    &_good {
        padding: 0 16px;
    }
    h3 {
        font-size: 32px;
        color: #000000;
        padding: 0 16px 32px;
        font-weight: 500;
        sup {
            color: #ef5445;
            margin-left: 6px;
        }
    }
    .item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 28px;
        padding: 0 16px;
        color: #999999;
        margin-bottom: 32px;
        &:last-child {
            margin-bottom: 0;
        }
        .iconicon_dianpu {
            font-size: 45px;
            flex: 0 0 52px;
        }
        &_center {
            flex: 1;
            .title {
                color: #000000;
            }
        }
        .arrowRight {
            flex: 0 0 40px;
        }
    }
}
</style>